import { VpIcon } from '@vtmn-play/react';
import { useTranslation } from 'react-i18next';

import {
  SpoGendersResponse,
  SpoNeedAndSegmentationResponseBenefitsItem,
  SpoSmSheetResponse,
} from '@spo/types';
import { useEffect, useState } from 'react';
import { useGenders } from '../../hooks/useGenders';
import { useNeedAndSegmentation } from '../../hooks/useNeedAndSegmentation';
import { capitalizeString } from '../../utils/text-display';
import { ProductBenefits } from '../productBenefits';
import { SmInfoContainer } from '../SmInfoContainer';
import { SmInfoDisplay } from '../smInfoDisplay';
import './smOfferInfos.scss';

export type UserNeedDetailsProps = {
  userNeed: string;
  userNeedId: number | undefined;
  usageSegmentation: string;
  benefits: SpoNeedAndSegmentationResponseBenefitsItem[];
};

const UserNeedDetails = ({
  userNeed,
  userNeedId,
  usageSegmentation,
  benefits,
}: UserNeedDetailsProps) => {
  return (
    <div className="offer-infos-user-need ">
      <div>{userNeed}</div>
      <div className="need-usage-subtitle">{`${userNeedId} - ${usageSegmentation}`}</div>
      {benefits.length ? <ProductBenefits benefits={benefits} inline /> : <></>}
    </div>
  );
};

export interface SmOfferInfosProps {
  sm: SpoSmSheetResponse | undefined;
}

export const SmOfferInfos = ({ sm }: SmOfferInfosProps) => {
  const { t } = useTranslation();
  const [userNeed, setUserNeed] = useState(t('sm-info.missing-information'));
  const [usageSegmentation, setUsageSegmentation] = useState(
    t('sm-info.missing-information'),
  );
  const [userSegmentation, setUserSegmentation] = useState(
    t('sm-info.missing-information'),
  );
  const [benefits, setBenefits] = useState<
    SpoNeedAndSegmentationResponseBenefitsItem[]
  >([]);

  const { data: genderData, isFetching: isGenderFetching } = useGenders(
    sm?.genders,
  );

  const { data: needAndSegData, isFetching: isNeedAndSegFetching } =
    useNeedAndSegmentation(sm?.userNeedId, sm?.userSegmentationTypeValueId);

  const displayGender = (genderData: SpoGendersResponse) => {
    return genderData
      ?.map((gender) => capitalizeString(gender.label))
      .join(', ');
  };

  useEffect(() => {
    if (needAndSegData) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      needAndSegData.userNeedLabel && setUserNeed(needAndSegData.userNeedLabel);
      needAndSegData.usageSegmentationLabel &&
        setUsageSegmentation(needAndSegData.usageSegmentationLabel);
      needAndSegData.userSegLabel &&
        setUserSegmentation(needAndSegData.userSegLabel);
      needAndSegData.benefits && setBenefits(needAndSegData.benefits);
    }
  }, [needAndSegData]);

  return (
    <SmInfoContainer
      title={t('sm-info.offer-infos')}
      icon={<VpIcon name="body-scan" />}
    >
      <SmInfoDisplay label={t('sm-info.gender')} isLoading={isGenderFetching}>
        <span className="capitalized">
          {genderData && displayGender(genderData)}
        </span>
      </SmInfoDisplay>
      <SmInfoDisplay
        label={t('sm-info.user-seg')}
        isLoading={isNeedAndSegFetching}
      >
        <span className="capitalized">{userSegmentation}</span>
      </SmInfoDisplay>
      <SmInfoDisplay
        label={t('sm-info.user-need')}
        isLoading={isNeedAndSegFetching}
      >
        <UserNeedDetails
          userNeed={userNeed}
          userNeedId={sm?.userNeedId}
          usageSegmentation={usageSegmentation}
          benefits={benefits}
        />
      </SmInfoDisplay>
    </SmInfoContainer>
  );
};
